export default __webpack_public_path__ + "static/media/yellow-tea.cedcf626.png";